export default [
  {
    field: 'dataCriacao',
    id: 'dataCriacao',
    label: 'Data',
    minWidth: 10,
  },
  {
    field: 'imagem',
    id: 'imagem',
    label: 'Imagem',
    minWidth: 50,
    align: 'center',
  },
  {
    field: 'titulo',
    id: 'titulo',
    label: 'Título',
    minWidth: 50,
    align: 'left',
  },
  {
    field: 'descricao',
    id: 'descricao',
    label: 'Descrição',
    minWidth: 50,
    align: 'left',
  },
  // {
  //   field: 'versao',
  //   id: 'versao',
  //   label: 'Versão',
  //   minWidth: 150,
  //   align: 'left',
  // },
  {
    field: 'uf',
    id: 'uf',
    subfield: 'sigla',
    label: 'UF',
    minWidth: 50,
    align: 'left',
  },
  {
    field: 'urlConteudo',
    id: 'urlConteudo',
    label: 'URL',
    minWidth: 50,
    align: 'left',
  },
  {
    field: 'status',
    id: 'status',
    label: 'Ações',
    minWidth: 100,
    maxWidth: 130,
    align: 'left',
  },
];
